import React from 'react';
import { Text, Button, SimpleGrid, VStack, Image, Stack, LinkBox, LinkOverlay, Flex, Icon, Box } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

import HomeLayout from '../../components/layouts/homelayout';
import Hero from '../../components/sections/hero';
import careershero from '../../components/ui/careers_hero.jpeg';
import HeroWithBackgroundImage from '../../components/sections/herowithbackgroundimage';
import HeroWithRightMedia from '../../components/sections/herowithrightmedia';
import ReactPlayer from 'react-player/youtube';
import HeroWithLeftMedia from '../../components/sections/herowithleftmedia';
import GridCard from '../../components/sections/gridcard';

import dcJobs from '../../components/ui/globalcareers/dc-jobs.png';
// import asiaCard from '../../components/ui/AsiaCard.jpg';
// import northAmericaCard from '../../components/ui/NorthAmericaCard.jpg';
// import europeCard from '../../components/ui/EuropeCard.jpg';
// import colCard from  '../../components/ui/globalcareers/col-card.jpg';
// import mhwCard from  '../../components/ui/globalcareers/mhw-card.jpg';
// import sorCard from  '../../components/ui/globalcareers/sor-card.jpg';
// import pranaCard from  '../../components/ui/globalcareers/prana-card.jpg';
import cassieHughes from '../../components/ui/globalcareers/cassie-hughes.png';
import diversityJobs from '../../components/ui/globalcareers/diversity-jobs.jpg';
import bestInState from '../../components/ui/globalcareers/best-in-state.jpg';
import diversityCard from '../../components/ui/globalcareers/diversity-card.jpg';
import newsweekCard from '../../components/ui/globalcareers/newsweek-card.png';

function Careers() {
  return (
    <HomeLayout>
      <Stack w="full" pt="90px">
        <Hero
          title={`READY FOR YOUR NEXT ADVENTURE?\nLET’S EXPLORE!`}
          backgroundImage={careershero}
        />
      </Stack>
      <VStack justify="center" pt={10}>
        <Box display="none">
          <HeroWithBackgroundImage
            title="LOOKING FOR DISTRIBUTION CENTER JOBS?"
            backGroundImage={dcJobs}
            cta={<Button size='lg' px={6} bg='#0693e3' color='white' borderRadius={10}>CLICK HERE<Icon color="white" w={5} h={5} as={ExternalLinkIcon} pl="4px"/></Button>}
          />
          {/* <Text fontSize='4xl' fontWeight='bold'>OUR REGIONS</Text>
          <Text>We are a global company and have locations in 26 countries.</Text>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} py={4}>
            <GridCard
              title='ASIA'
              backgroundImage={asiaCard}
              href='#'
            />
            <GridCard
              title='NORTH AMERICA'
              backgroundImage={northAmericaCard}
              href='#'
            />
            <GridCard
              title='EUROPE'
              backgroundImage={europeCard}
              href='/careers/ourbrands'
            />
          </SimpleGrid> */}
        </Box>
        {/* <Text fontSize='4xl' fontWeight='bold'>OUR REGIONS</Text>
        <Text>We are a global company and have locations in 26 countries.</Text> */}
        {/* <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} py={4}>
          <GridCard
            title='ASIA'
            backgroundImage={asiaCard}
            href='#'
          />
          <GridCard
            title='NORTH AMERICA'
            backgroundImage={northAmericaCard}
            href='#'
          />
          <GridCard
            title='EUROPE'
            backgroundImage={europeCard}
            href='/careers/ourbrands'
          />
        </SimpleGrid> */}
        {/* <Text fontSize='4xl' fontWeight='bold'>OUR BRANDS</Text> */}
        {/* <Text>We design, develop, market and distribute active outdoor and lifestyle products under the following brands.</Text>
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={10} py={4}>
          <GridCard
            title='COLUMBIA'
            backgroundImage={colCard}
            href='/careers/our-brands-group/?tab-78baa3e833ecb8b09e4'
          />
          <GridCard
            title='SOREL'
            backgroundImage={sorCard}
            href='/careers/our-brands-group/?tab-9d37deaf387dfeb99f5'
          />
          <GridCard
            title='MOUNTAIN HARDWEAR'
            backgroundImage={mhwCard}
            href='/careers/our-brands-group/?tab-7f9133205962d06a60c'
          />
          <GridCard
            title='PRANA'
            backgroundImage={pranaCard}
            href='/careers/our-brands-group/?tab-05cf9eb2b0103558eb1'
          />
        </SimpleGrid> */}
        <HeroWithRightMedia 
          media={<ReactPlayer url="https://www.youtube.com/embed/khorCFA-cn8?autoplay=0&rel=0&enablejsapi=1&wmode=opaque" />} 
          title="WHY COLUMBIA SPORTSWEAR COMPANY?" subTitle="Nestled in the Pacific Northwest, our Global Headquarters was founded in 1938 to bring people closer to the outdoors. We thrive in a culture full of people who live to “Connect Active People with their Passions” which could be working on creating product, managing our budgets, delivering the product or help to develop our people to deliver the quality product throughout the world." 
          // cta={<Button size='lg' px={6} bg='#0693e3' color='white' borderRadius={10}>LEARN MORE</Button>}
        />
        <HeroWithLeftMedia media={<Image borderRadius={10} src={cassieHughes} />} title={`"Every day inspires me a little bit more to get outside, test our gear, and love the world that we live in."`} subTitle="– Cassie Hughes, Canada, Sales Operations" />
        <Text fontSize='4xl' fontWeight='bold'>AWARDS AND RECOGNITION</Text>
        <Text>We are proud to be a company of innovators. By constantly developing new and better products, we believe we can improve the way our customers enjoy the outdoors. The industry is taking notice too…</Text>
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={10} py={4}>
          <GridCard
            title={`2020\n"AMERICA’S BEST EMPLOYERS FOR DIVERSITY"`}
            backgroundImage={diversityCard}
            href='#'
          />
          <GridCard
            title={`2020 NEWSWEEK\n"BEST-IN-STATE CUSTOMER SERVICE"`}
            backgroundImage={bestInState}
            href='#'
          />
          <GridCard
            title={`2021 NEWSWEEK\n"BEST CUSTOMER SERVICE"`}
            backgroundImage={newsweekCard}
            href='#'
          />
          <Stack>
            <LinkBox as='a'>
              <LinkOverlay href="https://diversityjobs.com/employer/company/12013/Columbia-Sportswear" isExternal>
                <Flex h="192px"
                      w="350px"
                      bgRepeat="no-repeat"
                      borderRadius={10}
                      bgImage={diversityJobs}
                >
                </Flex>
              </LinkOverlay>
            </LinkBox>
          </Stack>
        </SimpleGrid>
      </VStack>
    </HomeLayout>
  );
}

export default Careers;
